var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful/render-entry.j2"] = require( "macros/contentful/render-entry.j2" );
dependencies["condition/condition-header.j2"] = require( "condition/condition-header.j2" );
dependencies["condition/condition-scale.j2"] = require( "condition/condition-scale.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-condition.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.vintage.condition",""]));
frame.set("vintageConditionDetails", t_1, true);
if(frame.topLevel) {
context.setVariable("vintageConditionDetails", t_1);
}
if(frame.topLevel) {
context.addExport("vintageConditionDetails", t_1);
}
env.getTemplate("macros/contentful/render-entry.j2", false, "product/templates/product-condition.j2", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
t_2.getExported(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
if(t_2.hasOwnProperty("renderEntry")) {
var t_5 = t_2.renderEntry;
} else {
cb(new Error("cannot import 'renderEntry'")); return;
}
context.setVariable("renderEntry", t_5);
output += "<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <a href=\"#condition__panel\" id=\"condition__tab\" class=\"o-accordion__tab c-product-details__tab js-accordion-tab\" aria-selected=\"true\" aria-controls=\"condition__panel\" aria-expanded=\"false\" role=\"tab\"data-accordion-title=\"condition\" data-qa-condition-accordion>\n\n            ";
env.getTemplate("condition/condition-header.j2", false, "product/templates/product-condition.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n\n            <span class=\"o-accordion__control c-product-condition__collapse\" title=\"collapse\"></span>\n        </a>\n\n    </div>\n\n</div>\n\n<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <div id=\"condition__panel\" class=\"s-cms o-accordion__panel js-accordion-panel c-product-details__section\" aria-labelledby=\"condition__tab\" aria-hidden=\"false\" role=\"tabpanel\">\n\n            ";
env.getTemplate("condition/condition-scale.j2", false, "product/templates/product-condition.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n\n            <p class=\"c-condition__details\">\n                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "vintageConditionDetails"), env.opts.autoescape);
output += "\n            </p>\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"conditionModules")),"product_condition-details")) {
var t_14;
t_14 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"conditionModules")),"product_condition-details");
frame.set("entry", t_14, true);
if(frame.topLevel) {
context.setVariable("entry", t_14);
}
if(frame.topLevel) {
context.addExport("entry", t_14);
}
output += "\n                ";
output += runtime.suppressValue((lineno = 34, colno = 28, runtime.callWrap(t_5, "renderEntry", context, [runtime.contextOrFrameLookup(context, frame, "entry")])), env.opts.autoescape);
;
}
output += "</div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-condition.j2"] , dependencies)